import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useModal } from '@gsa/afp-component-library';
import { setCurrentAdditionalAction } from '../../../../reducers/additionals-reducer';
import ChangeSelectionModal from '../../../vehicle-referral/components/vehicle-selection/change-selection-modal';
import AdditionalsSelectOptions from '../../vehicle-request/steps/selected-options/select-options';
import './option-selection.scss';

export default function AdditionalsOptionSelection() {
  const [option, setOption] = useState(null);
  const { isOpen, closeModal } = useModal();

  const dispatch = useDispatch();
  const handleCancel = () => {
    closeModal();
    dispatch(setCurrentAdditionalAction(option));
    setOption(null);
  };

  const handleChangeClose = () => {
    closeModal();
    setOption(null);
  };

  return (
    <div>
      <ChangeSelectionModal
        isOpen={isOpen}
        handleClose={handleChangeClose}
        handleCancel={handleCancel}
      />
      <>
        <AdditionalsSelectOptions />
      </>
    </div>
  );
}
